export default "/images/870b47c850c44b0160b49f49600ab038.avif";